import React from 'react';
import { FlameIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const perks = ['Accesso digitale immediato', 'Tutti i 3 bonus inclusi', 'Pagamento unico', 'Mai un abbonamento'];
export function FinalCta() {
  return <section className="w-full bg-ink py-20 text-white sm:py-28" data-id="element-52" data-mp="19cuos5ouiypr">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-53" data-mp="15ckkqykm6idj">
        <p className="mb-5 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-sunshine" data-id="element-54" data-mp="1jclii55l19os">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="1ed0hlp6uqr9f" />
          Ultima occasione — offerta limitata
        </p>
        <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl md:text-5xl" data-id="element-56" data-mp="1t2ercyecbapc">
          I tuoi figli meritano di costruire qualcosa di concreto
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-57" data-mp="224o2nqhfn83s">
          Regala loro oltre 100 progetti di robot, 3 bonus gratuiti e ore di
          divertimento senza schermi — il tutto con un unico, semplice
          pagamento.
        </p>
        <div className="mt-10" data-id="element-58" data-mp="s4flbz25y345">
          <CtaButton data-id="element-59" data-mp="s5qmdr484wrk">Sì! Voglio MakerLab adesso</CtaButton>
        </div>
        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/70" data-id="element-60" data-mp="x421ag9dlxgn">
          {perks.map(p => <li key={p} className="flex items-center gap-1.5" data-id="element-61" data-mp="124g8jw35l3dm">
              <CheckIcon className="h-4 w-4 text-sunshine" aria-hidden="true" data-id="element-62" data-mp="16501engp1kty" />
              {p}
            </li>)}
        </ul>
      </div>
    </section>;
}